export const icon = [
  '33 33',
  `
  <title>SleekFlow Logo</title>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Sleekflow_logo_2x" fill-rule="nonzero">
            <g id="Logo_circle">
                <circle id="Oval" fill="#0F6593" cx="16.5" cy="16.5" r="16.5"></circle>
                <polyline id="Fill-2" fill="#FFFFFE" points="26.7056625 22.4247375 26.7056625 10.635075 16.4956275 16.529865 11.3123175 13.62768 21.6005625 7.6875975 16.4956275 4.74012 6.2852625 10.635075 6.2852625 22.4247375 16.4956275 16.529865 21.6789375 19.43205 11.39061 25.3721325 16.4956275 28.3196925 26.7056625 22.4247375"></polyline>
            </g>
        </g>
    </g>
`
];
